<template>
	<a
		class="site_button"
		:class="[theme, type, is_hovered ? 'is_hovered' : null]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink ? parsedLink.target : null"
		@mouseenter="handleMouseEnter"
		@mouseleave="handleMouseLeave"
		ref="site_button"
	>
		<span class="hover_arrow">&rarr;</span>

		<span
			class="label"
			v-html="button_label ? button_label : parsedLink ? parsedLink.title : ''"
		></span>

		<span class="arrow">&rarr;</span>
	</a>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		is_hovered: {
			type: Boolean,
			default: false,
		},
		target: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
		handleMouseEnter() {
			this.hovered = true;
			this.$emit('mouseenter');
		},
		handleMouseLeave() {
			this.hovered = false;
			this.$emit('mouseleave');
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	padding: 16px 24px 12px;
	border-radius: 30px;
	text-decoration: none;
	/* height: 60px; */
	display: inline-flex;
	justify-content: flex-start;
	/* align-items: center; */
	transition: 0.2s ease all;
	color: var(--fpe-blue);
	border: 1px solid var(--white);
	overflow: hidden;
	min-width: auto;
	position: relative;
	z-index: 1;
	/* box-shadow: 0px -0px 0 var(--fpe-blue); */

	.stay_in_touch & {
		color: var(--fpe-light-grey);
	}

	@media (max-width: $laptop) {
		min-width: auto;
	}

	&.dark {
		border: 1px solid var(--fpe-light-grey);
	}

	&.video {
		background: var(--fpe-light-grey);
	}

	@media (hover) {
		&:hover {
			background: var(--white);
			transition: 0.2s ease all;
			cursor: pointer;
			/* box-shadow: 1px -1px 0 var(--fpe-blue); */

			.label {
				color: var(--fpe-blue);
				transform: translateX(20px);
			}

			.arrow {
				transform: translateX(50px);
				opacity: 0;
			}

			.hover_arrow {
				transform: translateX(40px);
				opacity: 1;
			}
		}
	}

	&[is_hovered='true'],
	&.is_hovered {
		background: var(--white);
		transition: 0.2s ease all;
		cursor: pointer;

		.label {
			color: var(--fpe-blue);
			transform: translateX(20px);
		}

		.arrow {
			transform: translateX(50px);
			opacity: 0;
		}

		.hover_arrow {
			transform: translateX(40px);
			opacity: 1;
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal 300 16px/16px var(--primary-font-family);
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		/* margin-left: 20px; */
		text-transform: uppercase;

		.post_tile & {
			text-transform: none;
			font: normal normal 300 14px/18px var(--primary-font-family);
		}
	}

	.label {
		transition: 0.2s ease all;
	}

	.arrow {
		position: relative;
		margin-left: 10px;
		transition: 0.2s ease all;
	}

	.hover_arrow {
		position: absolute;
		left: -20px;
		opacity: 0;
		transition: 0.2s ease all;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PrimaryButton.vue